export const extractPrismicIdFromUrl = (path: string) => {
  if (path.length !== 16 && path[16] !== '-') return;
  return path.slice(0, 16);
};
